import * as React from 'react';
import dayjs from 'dayjs';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import 'dayjs/locale/en-gb';
export  function TTPDateTimePicker(props) {
    // const [value, setValue] = React.useState(null);
    const handleChange = (e) => {
        props.onChange(e.$d.toISOString().substring(0,19))
    }
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb" >
            <Stack spacing={2} sx={{ minWidth: 305 }}>
                <DateTimePicker
                    value={props.value??null}
                    onChange={handleChange}
                    referenceDate={dayjs(new Date().toISOString().substring(0,16))}
                />
                <Typography>
                {(props.label??false) ? 'Please Select a Date and Time' : props.label}
                </Typography>
            </Stack>
        </LocalizationProvider>
    );
}

export default TTPDateTimePicker